import { render, staticRenderFns } from "./AdminInsentif.vue?vue&type=template&id=afe72652&scoped=true"
import script from "./AdminInsentif.vue?vue&type=script&lang=js"
export * from "./AdminInsentif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe72652",
  null
  
)

export default component.exports